/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconAdd/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconAdd({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconAdd",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconAdd.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-Z283H5V': alignSelf,'--mt-2-Z283H5V': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z283H5V': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z283H5V': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z283H5V': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z283H5V': opacity,'--w-10-Z283H5V': typeof width === 'number' ? `${width}px` : width,'--h-11-Z283H5V': typeof height === 'number' ? `${height}px` : height,'--a-7-Z283H5V': isAnimated ? animation : "none",'--sd-8-Z283H5V': isAnimated ? strokeDashoffset : 0,'--sd-9-Z283H5V': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconAdd.SvgPath"
  data-view-path={viewPath}
 d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
 style={{'--f-12-Z283H5V': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}